<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <heading-view :right-column="show_table_view"></heading-view>

        <!--<add-view v-if="show_add_view"></add-view>-->
        <employee-add-view v-if="show_add_view"></employee-add-view>
        <employee-table-view v-if="show_table_view"></employee-table-view>

        <!--<v-tooltip top>-->
            <!--<template v-slot:activator="{ on, attrs }">-->

                <!--<v-btn v-bind="attrs" v-on="on" fab bottom right dark fixed color="primary" v-if="show_table_view"-->
                       <!--@click="showAddForm()">-->
                    <!--<v-icon>mdi-plus</v-icon>-->
                <!--</v-btn>-->
            <!--</template>-->
            <!--<span>Dodaj novog djelatnika</span>-->
        <!--</v-tooltip>-->

        <user-roles-dialog></user-roles-dialog>
    </v-container>
</template>

<script>
    import {serverBus} from "../../main";

    // import AddView from "../add/AddView";
    import EmployeeTableView from '../employee/EmployeeTableView'
    import HeadingView from '../heading/HeadingView'
    import EmployeeAddView from '../employee/EmployeeAddView'
    import UserRolesDialog from "../dialogs/UserRolesDialog";

    export default {

        components: {
            UserRolesDialog,
            // AddView,
            EmployeeTableView,
            HeadingView,
            EmployeeAddView
        },

        created: function () {
            let table = 'djelatnik';
            this.$store.commit('setTable', table);

            this.show_add_view = this.$route.matched[0].name === 'EmployeeAddView';
            this.show_table_view = this.$route.matched[0].name === 'EmployeeTableView';

            serverBus.$on('show-employee-add-form', (item) => {
                // if (this.$useDialog()) {
                //     serverBus.$emit('show-add-edit-dialog', table, item);
                // } else {
                this.$navigate('/admin/djelatnik/add' + (item.id > 0 ? '/' + item.id : ''));
                // }
            });

            serverBus.$on('show-employee-profile', (item) => {
                this.$navigate('/admin/' + table + '/pregled/' + item.id);
            });
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-employee-add-form', {id: -1});
            },
        },

        beforeDestroy() {
            serverBus.$off('show-employee-add-form');
            serverBus.$off('show-employee-profile');
        },

        data: function () {
            return {
                show_add_view: false,
                show_table_view: false
            };
        }
    }
</script>